// extracted by mini-css-extract-plugin
export default {"container":"private_container__6ga-c","sidebarWrp":"private_sidebarWrp__eoUSr","body":"private_body__Lyop7","top":"private_top__XZSnH","children":"private_children__FPBc7"};